import { connect } from 'react-redux';
import { getCompanyName, getNonDefaultLocales } from 'store/modules/company';
import { save as savePage } from 'store/modules/pageBuilder';
import { update as updatePage, makeDraft } from 'store/modules/pages';
import { load as loadRedirects } from 'store/modules/hostnames';
import SinglePageSettings from '../components/PageSettings/SinglePageSettings';

export default connect(
  (state) => {
    const {
      pageBuilder: { saving },
      hostnames,
    } = state;

    return {
      saving: !!saving,
      nonDefaultLanguages: getNonDefaultLocales(state),
      hostnames,
      companyName: getCompanyName(state),
    };
  },
  {
    savePage,
    updatePage,
    loadRedirects,
    makeDraft,
  },
)(SinglePageSettings);
